var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group-text',_vm._b({},'b-input-group-text',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }